module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/UZ-6c8455445458023811ad1f539b8ea4f7.png";